import RewardServiceApp from '@repo/reward-service/RewardServiceApp';

import './index.css';

function App() {
  return <RewardServiceApp />;
}

export default App;
